import React from 'react';

const tennisImages = [
  { src: 'images/tennis/tennis_1.jpg', alt: 'Winning a trophy on court' },
  { src: 'images/tennis/tennis_2.jpg', alt: 'Trophy presentation at night' },
  { src: 'images/tennis/tennis_3.jpg', alt: 'Tennis doubles group' },
  { src: 'images/tennis/tennis_4.jpg', alt: 'Post-match group photo' },
  { src: 'images/tennis/tennis_5.jpg', alt: 'Trophy celebration by the tree' },
];

const TennisGallery = () => {
  return (
    <div className="tennis-gallery-container">
      <div className="tennis-gallery-grid">
        {tennisImages.map((img, index) => (
          <div key={index} className="tennis-image-wrapper">
            <img src={img.src} alt={img.alt} className="tennis-sketch-img" />
          </div>
        ))}
      </div>
      <style>{`
        .tennis-gallery-container {
          margin: 40px auto;
          max-width: 900px;
          padding: 20px;
        }
        .tennis-gallery-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
          gap: 20px;
          justify-items: center;
        }
        .tennis-image-wrapper {
          width: 150px;
          height: 150px;
          overflow: hidden;
          border-radius: 50%;
          border: 3px solid #11ABB0;
          box-shadow: 0 4px 8px rgba(0,0,0,0.2);
          transition: transform 0.3s ease;
        }
        .tennis-image-wrapper:hover {
          transform: scale(1.1);
        }
        .tennis-sketch-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          filter: grayscale(100%) contrast(150%) brightness(90%);
          /* A "sketch" effect approximation using CSS filters */
        }
        @media (max-width: 768px) {
          .tennis-gallery-grid {
            grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
          }
          .tennis-image-wrapper {
            width: 120px;
            height: 120px;
          }
        }
      `}</style>
    </div>
  );
};

export default TennisGallery;
